import {
  convertAmount,
  defaultDestinationForCountry,
  DEFAULT_CURRENCY
} from '@/helpers/currency'

function applyDestinationFromCountry (store) {
  const next = defaultDestinationForCountry(store.state.country, store.state.localCurrencies)
  if (store.state.currenciesLoaded && store.state.currenciesByCode[next]) {
    store.commit('setDestinationCurrency', next)
  }
}

export default async function ({ $axios, store }, inject) {
  inject('convertCurrency', (amount, from, to) => {
    const map = store.state.currenciesByCode
    const dest = to != null ? to : store.state.destinationCurrency
    return convertAmount(amount, from, dest, map)
  })

  try {
    const data = await $axios.$get('site/currencies')
    const { currencies, localCurrencies } = data
    store.commit('setCurrenciesPayload', { currencies, localCurrencies })

    const fallbackLocal = defaultDestinationForCountry(store.state.country, store.state.localCurrencies)
    const next = store.state.currenciesByCode[fallbackLocal]
      ? fallbackLocal
      : DEFAULT_CURRENCY

    store.commit('setDestinationCurrency', next)

    if (process.client) {
      store.subscribe((mutation) => {
        if (mutation.type === 'setCountry') {
          applyDestinationFromCountry(store)
        }
      })
    }
  } catch (e) {
    if (process.dev) {
      console.warn('[currencies] site/currencies failed', e)
    }
  }
}
